import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 41,
    seconds: 12
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('corralesEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 41 * 60 * 1000 + 12 * 1000;
        localStorage.setItem('corralesEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 41 * 60 * 1000 + 12 * 1000;
      localStorage.setItem('corralesEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 41 * 60 * 1000 + 12 * 1000;
        localStorage.setItem('corralesEndTime', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-1.5 md:gap-2 font-display font-bold ${className}`} data-id="element-42">
      <div className="flex flex-col items-center bg-brand-ink text-white px-2.5 py-1.5 md:px-4 md:py-2.5 rounded-lg border-2 md:border-4 border-brand-green shadow-lg min-w-[58px] md:min-w-[80px]" data-id="element-43">
        <span className="text-2xl md:text-4xl leading-none" data-id="element-44">
          {fmt(timeLeft.hours)}
        </span>
        <span className="text-[9px] md:text-xs uppercase text-brand-greenLight mt-0.5 tracking-widest" data-id="element-45">
          Horas
        </span>
      </div>
      <span className="text-2xl md:text-4xl text-brand-green font-black" data-id="element-46">
        :
      </span>
      <div className="flex flex-col items-center bg-brand-ink text-white px-2.5 py-1.5 md:px-4 md:py-2.5 rounded-lg border-2 md:border-4 border-brand-green shadow-lg min-w-[58px] md:min-w-[80px]" data-id="element-47">
        <span className="text-2xl md:text-4xl leading-none" data-id="element-48">
          {fmt(timeLeft.minutes)}
        </span>
        <span className="text-[9px] md:text-xs uppercase text-brand-greenLight mt-0.5 tracking-widest" data-id="element-49">
          Min
        </span>
      </div>
      <span className="text-2xl md:text-4xl text-brand-green font-black" data-id="element-50">
        :
      </span>
      <div className="flex flex-col items-center bg-brand-ink text-white px-2.5 py-1.5 md:px-4 md:py-2.5 rounded-lg border-2 md:border-4 border-brand-green shadow-lg min-w-[58px] md:min-w-[80px]" data-id="element-51">
        <span className="text-2xl md:text-4xl leading-none" data-id="element-52">
          {fmt(timeLeft.seconds)}
        </span>
        <span className="text-[9px] md:text-xs uppercase text-brand-greenLight mt-0.5 tracking-widest" data-id="element-53">
          Seg
        </span>
      </div>
    </div>;
}